import { FelaCSSWithCustomSelectors } from '@bridebook/ui';
import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import { colors, spacing } from '@bridebook/ui/src/themes/variables';

interface IArgs {
  expanded: boolean;
  isExpandable: boolean;
}

interface IStyles {
  headingWrapper: FelaCSS;
  chevron: FelaCSS;
  icon: FelaCSS;
  expandedContentWrapper: FelaCSS;
  guestsInfo: FelaCSSWithCustomSelectors;
  info: FelaCSSWithCustomSelectors;
  label: FelaCSS;
  priceLabel: FelaCSS;
  root: FelaCSSWithCustomSelectors;
  heading: FelaCSS;
  included: FelaCSS;
  showDetailsLink: FelaCSSWithCustomSelectors;
  hideDetailsLink: FelaCSSWithCustomSelectors;
}

const styles = ({ expanded, isExpandable }: IArgs): IStyles => ({
  headingWrapper: {
    flexDirection: 'row',
    gap: '16px',
    cursor: isExpandable ? 'pointer' : 'default',
  },
  heading: { flexDirection: 'column', gap: '4px', flex: 1 },
  chevron: {
    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.25s ease-in-out',
    width: '20px',
    height: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: spacing[2],
    visibility: isExpandable ? 'visible' : 'hidden',
  },
  expandedContentWrapper: {
    desktopDesign: {
      paddingLeft: '60px',
    },
  },
  guestsInfo: {
    fontDefault: 14,
    display: 'inline-block',
    '& .guest-count': {
      display: 'inline',
      fontDefaultSemiBold: 14,
    },
  },
  info: {
    color: colors.space75,
    fontDefault: 14,
    whiteSpace: 'pre-line',
    desktopDesign: {
      paddingTop: 1,
    },
  },
  label: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    color: colors.space,
    fontDefaultSemiBold: 18,
  },
  priceLabel: {
    fontDefaultSemiBold: 16,
  },
  root: {
    border: `1px solid ${colors.space15}`,
    borderRadius: '8px',
    padding: 3,
    desktopDesign: {
      padding: 4,

      '&:hover .show-details-link': {
        textDecoration: 'underline',
      },
    },
  },
  included: {
    paddingTop: 2,
  },
  icon: {
    height: '25px',
    width: '25px',
    borderRadius: 25,
    backgroundColor: colors.indigoCrush20,
    justifyContent: 'center',
  },
  showDetailsLink: {
    fontDefault: 14,
    transition: 'height 200ms ease-in-out, opacity 100ms ease-in-out',
    overflow: 'hidden',
    height: expanded ? '0px' : '28px',
    opacity: expanded ? 0 : 1,
    justifyContent: 'center',
    desktopDesign: {
      height: expanded ? '0px' : '36px',
    },
  },
  hideDetailsLink: {
    paddingTop: 4,
    paddingBottom: 2,
    fontDefault: 14,
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

export default styles;
